// Sticky "Order Now" bar for snippets/pg-sticky-buy.liquid.
if (!customElements.get('pg-sticky-buy')) {
  customElements.define(
    'pg-sticky-buy',
    class PgStickyBuy extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.orderLink = this.querySelector('[data-order]');
        this.cartButton = this.querySelector('[data-cart]');

        this.orderLink.addEventListener('click', this.onOrder.bind(this));
        this.cartButton.addEventListener('click', () => {
          if (this.mainButton && !this.mainButton.disabled) this.mainButton.click();
        });

        // Show the bar only while the main buy buttons are off screen
        const target = this.mainButton?.closest('.product-form__buttons') || this.mainButton;
        if (target) {
          this.observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting), {
            rootMargin: '0px 0px -40px 0px',
          });
          this.observer.observe(target);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        document.body.classList.remove('pg-sticky-visible');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', show ? '0' : '-1'));
        document.body.classList.toggle('pg-sticky-visible', show);
      }

      currentVariantId() {
        const input = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
        return input ? input.value : this.querySelector('[data-variant-id]')?.dataset.variantId;
      }

      currentQuantity() {
        const qty = document.getElementById(`Quantity-${this.sectionId}`);
        return Math.max(1, Number(qty?.value) || 1);
      }

      onOrder(event) {
        if (this.orderLink.classList.contains('is-disabled')) {
          event.preventDefault();
          return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        if (this.orderLink.classList.contains('is-loading')) return;
        this.orderLink.classList.add('is-loading');

        const id = Number(this.currentVariantId());
        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: this.currentQuantity() }] }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Add to cart failed');
            window.location.href = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}checkout`;
          })
          .catch(() => {
            this.orderLink.classList.remove('is-loading');
            window.location.href = `${window.routes.cart_url}/${id}:${this.currentQuantity()}`;
          });
      }

      onVariantChange({ data }) {
        if (!data || data.sectionId !== this.sectionId || !data.html) return;
        const fresh = data.html.getElementById(this.id);
        if (!fresh) return;

        const info = this.querySelector('[data-sticky-info]');
        const freshInfo = fresh.querySelector('[data-sticky-info]');
        if (info && freshInfo) info.innerHTML = freshInfo.innerHTML;

        const available = fresh.querySelector('[data-variant-id]')?.dataset.available === 'true';
        const variantId = fresh.querySelector('[data-variant-id]')?.dataset.variantId;
        const label = this.querySelector('[data-order-label]');

        this.orderLink.classList.toggle('is-disabled', !available);
        this.orderLink.toggleAttribute('aria-disabled', !available);
        if (variantId) this.orderLink.href = `${window.routes.cart_url}/${variantId}:1`;
        if (label) label.textContent = available ? label.dataset.label : label.dataset.soldout;
        this.cartButton.disabled = !available;
      }
    }
  );
}
